// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__DK_qF","light":"styles_light__5vqLj","dark":"styles_dark__IggBg"};